import { Component, OnInit } from '@angular/core';

import { User } from '../../models/user';
import { Route, ActivatedRoute } from '@angular/router';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { UserService } from 'src/app/services/user.service';
import { ModalService } from 'src/app/services/modal.service';
import { ProductService } from 'src/app/services/product.service';
import { CompanyService } from 'src/app/services/company.service';

@Component({
    templateUrl: 'quote-view.component.html',
    styleUrls: ['./quote-view.component.scss']
})

export class QuoteViewComponent implements OnInit {
    currentUser: User;
    products: any[] = [];
    productId: any;
    labelId: any;
    customerId: any;
    currentProduct: any;
    currentLabel: any;
    currentQuote: any;
    quoteId: any;

    constructor(
        private userService: UserService,
        public modalService: ModalService,
        public productService: ProductService,
        public route: ActivatedRoute,
        public companyService: CompanyService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }

    ngOnInit() {
        this.quoteId = this.route.snapshot.paramMap.get("id");
        this.loadQuote(this.quoteId);
    }

    deleteUser(_id: string) {
        this.userService.delete(_id).subscribe(() => { this.loadAllProducts() });
    }

    private loadAllProducts() {
        this.productService.getAll(this.currentUser).subscribe(products => { this.products = products; console.log(this.products); });

    }

    editProduct() {
        this.modalService.openEditProduct();
    }

    loadLabel(labelId: any) {
        this.productService.getOneLabel(labelId).subscribe(value => {
            console.log(value);
            this.currentLabel = value;
            this.productService.currentLabel = value;
        });
    }

    loadQuote(quoteId: any) {
        this.currentQuote = null;
        this.companyService.currentQuote = null;
        console.log('-------------getQuote');
        this.companyService.getOneQuote(quoteId).subscribe(value => {
            console.log('-------------quoteLoaded');
            console.log(value);
            this.currentQuote = value;
            this.companyService.currentQuote = value;
        });
    }

    removeCustomization(customization: any) {
        this.productService.removeCustomization(this.productService.currentProduct._id, customization).subscribe(value => {
            console.log(value);
        });
    }

    activateProduct() {
        this.productService.activateProduct(this.currentProduct._id).subscribe(value => {
            console.log(value);
        });
    }

    deactivateProduct() {
        this.productService.deactivateProduct(this.currentProduct._id).subscribe(value => {
            console.log(value);
        });
    }

    downloadFile(data) {
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        // window.open("data:application/pdf;base64," + data);
        let pdfWindow = window.open("")
        pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            encodeURI(data) + "'></iframe>"
        )
    }

    downloadQuotePdf(quoteId) {
        this.userService.getQuotePdf(quoteId).subscribe(value => {
            console.log(value);
            this.downloadFile(value['dataUrl']);
        });
    }
}